import { useCallback } from "react";

import { useProductOptionFormModelContext } from "../../../../../_shared/context";
import { useProductNewOptionFormModelContext } from "../../../../context";

export const useActions = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { onUpdate } = useProductNewOptionFormModelContext();

	const { hasError, isDirty, inSale } = viewModel;
	const isValid = !hasError && isDirty;

	const handleChangeInSale = useCallback(
		(_input: boolean | undefined) => {
			if (inSale.value) {
				// 公開中なので、非公開にする
				onSetViewModel([
					{
						key: "inSale",
						value: {
							isEdited: false,
							value: false,
						},
					},
				]);
			} else {
				// 非公開中なので、公開にする
				onSetViewModel([
					{
						key: "inSale",
						value: {
							isEdited: true,
							value: true,
						},
					},
				]);
			}
		},
		[inSale.value, onSetViewModel],
	);

	return {
		isValid,
		onUpdate,

		// 公開非公開に関するプロパティ
		inSale,
		handleChangeInSale,
	};
};
